import React, { useState, useEffect } from 'react';
import './Library.css';

interface LibraryDoc {
  id: string;
  title: string;
  description: string;
  tags: string[];
  url: string;
}

interface LibraryCategory {
  category: string;
  documents: LibraryDoc[];
}

const Library: React.FC = () => {
  const [library, setLibrary] = useState<LibraryCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [activeCategory, setActiveCategory] = useState('Clinical');

  useEffect(() => {
    fetch('/api/library')
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setLibrary(data.data);
          if (data.data.length > 0) setActiveCategory(data.data[0].category);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const activeCategory_ = library.find(c => c.category === activeCategory);

  if (loading) {
    return (
      <div className="library-container">
        <div className="library-loading">Loading library...</div>
      </div>
    );
  }

  return (
    <div className="library-container">
      <div className="library-header">
        <h1>Resource Library</h1>
        <p>Review these materials before your simulation to strengthen your discovery conversations.</p>
      </div>

      <div className="library-tabs">
        {library.map(cat => (
          <button
            key={cat.category}
            className={`library-tab ${activeCategory === cat.category ? 'active' : ''}`}
            onClick={() => setActiveCategory(cat.category)}
          >
            {cat.category === 'Clinical' ? '🩺' : '⚖️'} {cat.category}
          </button>
        ))}
      </div>

      <div className="library-grid">
        {activeCategory_?.documents.map(doc => (
          <div key={doc.id} className="library-card">
            <div className="library-card-body">
              <h3>{doc.title}</h3>
              <p>{doc.description}</p>
              <div className="library-tags">
                {doc.tags.map(tag => (
                  <span key={tag} className="library-tag">{tag}</span>
                ))}
              </div>
            </div>
            <div className="library-card-footer">
              {doc.url && doc.url !== '#' ? (
                <a
                  href={doc.url}
                  className="library-open-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open Document
                </a>
              ) : (
                <span className="library-coming-soon">Coming soon</span>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="library-back">
        <a href="/dashboard">← Back to Dashboard</a>
      </div>
    </div>
  );
};

export default Library;
